<warning-message [show]="!isDefault && !isReadOnlyMode"
                 [(showDetails)]="showMessageDetails"
                 message="Some returns are using different forms than the default setup"
                 [hasDetails]="true">
    <div class="error-body">
        <div class="ws-flex-container-vertical ws-stretch">
            <span class="error-description">If you reset to default, the following changes will be applied:</span>
            <div class="error-container">
                @for (customReturn of customReturns; track trackByReturnId(customReturn)) {
                    <div>
                        <div class="form-error">
                            <span class="form-name">{{ customReturn.parcelAcctNum }}:</span>
                        </div>
                        <ul>
                            @for (customForm of customReturn.customForms; track customForm) {
                                <li (click)="toggleReports(customForm)">
                                    <div class="form-error" [class.can-dropdown]="customForm.customReports.length">
                                        @if (customForm.customReports.length) {
                                            <i class="fa fa-caret-right show-details"
                                               [class.open]="customForm['showReports']"></i>
                                        }
                                        <span class="form-name">
                                            <i class="state-icon fa"
                                               [ngClass]="getIconClass(customForm.action)"
                                               helpTooltip
                                               [tooltipText]="getIconTitle(customForm.action)"
                                               position="bottom"></i>
                                            <i class="fa fa-file-pdf-o"></i>
                                            {{ customForm.name }}
                                        </span>
                                    </div>
                                    @if (customForm.customReports.length) {
                                        <div class="report-dropdown" [class.open]="customForm['showReports']">
                                            <ul>
                                                @for (customReport of customForm.customReports; track customReport) {
                                                    <li>
                                                        <span>
                                                            <i class="state-icon fa"
                                                               [ngClass]="getIconClass(customReport.action)"
                                                               helpTooltip
                                                               [tooltipText]="getIconTitle(customReport.action)"
                                                               position="bottom"></i>
                                                            <i class="fa fa-file-text-o"></i>
                                                            {{ customReport.name + ' ' + customForm.name }}
                                                        </span>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
            <div class="reset-default">
                <button class="ace-btn btn-primary" (click)="showConfirmation()">Reset to Default</button>
            </div>
        </div>
    </div>
</warning-message>
